class ScrollAnimate {
    constructor(item) {
        this.item = item;
        this.sections = [];
        this.t_height = item.getBoundingClientRect().height;
        this.count = item.dataset.count;
        this.h = this.t_height / this.count;

        for (let j = 0; j < this.count; j++) {
            let pos = this.item.getBoundingClientRect().top + window.scrollY + (this.h * j);
            this.sections.push(pos);
        }

        this.item.querySelectorAll('[data-link]').forEach(link => {
            link.addEventListener('click', e => {
                const interactiveTarget = e.target.closest('a[href], button, input, textarea, select, summary');
                if (interactiveTarget && link.contains(interactiveTarget)) {
                    return;
                }

                e.preventDefault();
                let sectionId = link.dataset.link;
                if (sectionId) {
                    let sectionPos = this.sections[parseInt(sectionId) - 1];
                    if (sectionPos) {
                        window.scrollTo({
                            top: sectionPos - 30,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });

        window.addEventListener('scroll', () => {
            let pos = window.scrollY + (window.innerHeight / 2);

            this.sections.forEach((section, i) => {
                let nextSection = this.sections[i + 1] || Infinity;
                let sectionId = i + 1;
                let showElems = this.item.querySelectorAll(`[data-show="${sectionId}"]`);
                let hideElems = this.item.querySelectorAll(`[data-show]:not([data-show="${sectionId}"])`);

                let showOpacity = this.item.querySelectorAll(`[data-highlight="${sectionId}"]`);
                let hideOpacity= this.item.querySelectorAll(`[data-highlight]:not([data-highlight="${sectionId}"])`);

                if (pos > section && pos < nextSection) {
                    showElems.forEach(item => { 
                        item.style.opacity = 1;
                        
                        item.style.zIndex = 40;
                    });

                    hideElems.forEach(item => {
                        item.style.opacity = 0;
                        
                        item.style.zIndex = 20;
                    });

                    showOpacity.forEach(item => {
                        item.style.opacity = 1; 
                        item.style.textDecoration = 'underline';
                    });

                    hideOpacity.forEach(item => {
                        item.style.opacity = 0.4; 
                        item.style.textDecoration = 'none';
                    });
                }
            });
        });
    }
}




module.exports = ScrollAnimate;
module.exports.default = ScrollAnimate; // Allows `import mapbox from './mapbox.js';`

